import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('SDOH_REPORT_COMMUNITY_LIST')